import React from "react";

function SourceScopeBadge({ allowedLeadSources }) {
  if (allowedLeadSources === null || allowedLeadSources === undefined) {
    return <span className="scope-badge scope-badge-all">All</span>;
  }
  const list = Array.isArray(allowedLeadSources) ? allowedLeadSources : [];
  if (list.length === 0) {
    return <span className="scope-badge scope-badge-none">None</span>;
  }
  const joined = list.join(", ");
  const truncated = joined.length > 30 ? `${joined.slice(0, 30)}…` : joined;
  return (
    <span
      className="scope-badge scope-badge-specific"
      title={joined}
    >
      {truncated}
    </span>
  );
}

export default SourceScopeBadge;